// Nuvei's own examples rely on the card method having a specific name.
const CARD_METHOD = 'cc_card';
var CardFields;
(function (CardFields) {
    CardFields["CARD_HOLDER"] = "cardHolderName";
})(CardFields || (CardFields = {}));
function createPayment(methodName, accountId, fields, fieldsInstance) {
    if (accountId) {
        return {
            paymentOption: {
                userPaymentOptionId: accountId,
                CVV: fieldsInstance,
            },
        };
    }
    if (methodName === CARD_METHOD) {
        return {
            cardHolderName: fields?.[CardFields.CARD_HOLDER],
            paymentOption: fieldsInstance,
        };
    }
    return {
        paymentOption: {
            alternativePaymentMethod: {
                paymentMethod: methodName,
                ...fields,
            },
        },
    };
}

export { CARD_METHOD, CardFields, createPayment };
